class darkMode extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const root = document.documentElement;
        const attribute = 'data-dark-mode'
        const savedOption = localStorage.getItem(attribute)

        if (savedOption) {
            root.setAttribute(attribute, savedOption);
        } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            root.setAttribute(attribute, 'enabled');
        }

        this.addEventListener('click', () => {
            const attributeValue = root.getAttribute(attribute)
            if (attributeValue == 'enabled') {
                root.setAttribute(attribute, 'disabled')
                localStorage.setItem(attribute, 'disabled');
            } else {
                root.setAttribute(attribute, 'enabled')
                localStorage.setItem(attribute, 'enabled');
            }
        })
    }
}

customElements.define("cstm-dark-mode-button", darkMode);